import Plyr from 'plyr';

export class VideoUrl {
    /**
     * @type {Element|null}
     */
    target = null;

    /**
     * @type {HTMLButtonElement|null}
     */
    button = null;

    /**
     * @param {Element} target
     */
    constructor(target) {
        this.target = target;
        this.setupPlyrVideo();
    }

    setupPlyrVideo() {
        const plyrConfig = {
            storage: {
                enabled: false,
            },
            youtube: {
                noCookie: true,
                rel: false,
            },
            fullscreen: {
                iosNative: true,
            },
        };

        const plyrContainer = this.target.querySelector('[data-plyr-embed-id]');

        if (plyrContainer.dataset.iconUrl) {
            plyrConfig.iconUrl = plyrContainer.dataset.iconUrl;
        }

        const player = new window.Plyr(plyrContainer, plyrConfig);

        player?.on('enterfullscreen', function () {
            $('html').addClass('plyr-fullscreen');
        });
        player?.on('exitfullscreen', function () {
            $('html').removeClass('plyr-fullscreen');
        });
    }
}
